import { SELECIONAR_BILHETE, LIMPA_SELECIONAR_BILHETE } from '../../actions/types'

const initialState = undefined
const estadoInicial = {
  orgaoRegulador: null,
  regra: null,
  confsBilheteKm: []  
}

export default function reducerConfiguracaoBilheteSelecionado(state = estadoInicial, action = initialState) {
    switch (action.type) {
    case SELECIONAR_BILHETE: {
        if(action.payload == null){
            return estadoInicial
        }
        return action.payload;
    }
    
    case LIMPA_SELECIONAR_BILHETE: {
        return estadoInicial
    }

    default: {
      return state
    }
  }
}
